import React from "react";
import "../assets/styles/Card.css";

const Card = ({ style, className, size = "md", children }) => {
  return (
    <div className={`card card-${size}${className ? ` ${className}` : ""}`} style={style}>
      {children}
    </div>
  );
};

export default Card;
